<template>
  <div
    v-show="this.$store.state.layout !== 'landing'"
    class="card card-plain shadow-none"
    id="sidenavCard"
  >
    <button
      href="https://www.devratio.com.mx"
      target="_blank"
      class="mb-3 btn btn-outline-light btn-sm w-100"
      @click="signOut"
    >
      <i class="ri-logout-circle-r-line me-1"></i>
      Cerrar sesión
    </button>
  </div>
</template>
<script>
import img from "../../assets/img/illustrations/icon-documentation.svg";
import { useRouter } from "vue-router";
export default {
  name: "sidenav-card",
  props: ["textPrimary", "textSecondary", "iconClass"],
  data() {
    return {
      img,
    };
  },
  setup() {
    const router = useRouter();
    const signOut = () => {
      localStorage.removeItem("_token");
      localStorage.removeItem("_nombre");
      localStorage.removeItem("_id");
      localStorage.removeItem("_modulos");

      router.push({
        name: "login",
      });
    };

    return {
      signOut,
    };
  },
};
</script>
